// extracted by mini-css-extract-plugin
module.exports = {"calendarIcon":"calendarIcon--f2mTC","table":"table--GJ3wi"};